import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Import React FilePond
import { registerPlugin } from 'react-filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

// routes
import Router from './routes';
// components
import ScrollToTop from './components/ScrollToTop';
import UpgradeDialog from './components/UpgradeDialog';
import AnalyticsBridge from './analytics/AnalyticsBridge';
import ConsentPrompt from './analytics/ConsentPrompt';

import { bootstrapApp } from './events/actions';

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateType)

// ----------------------------------------------------------------------

export default function App() {
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(bootstrapApp());
    setLoading(false);
  }, [dispatch]);

  // Loading: Loading the redux state for user and session from the LocalStorage. Use Redux persist to handle this automatically.
  if (loading) {
    return <div />;
  }

  return (
    <>
      <AnalyticsBridge />
      <ConsentPrompt />
      <ScrollToTop />
      <Router />
      <UpgradeDialog />
    </>
  );
}
